export {
  ChainOfThoughtRoot as Root,
  type ChainOfThoughtRootProps as RootProps,
} from "./chainOfThought/ChainOfThoughtRoot";
export {
  ChainOfThoughtAccordionTrigger as AccordionTrigger,
  type ChainOfThoughtAccordionTriggerProps as AccordionTriggerProps,
} from "./chainOfThought/ChainOfThoughtAccordionTrigger";
export { ChainOfThoughtPrimitiveParts as Parts } from "@assistant-ui/core/react";
